import React from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'

import { Button } from '@jelly/ui'
import { NextivaLogo } from '@jelly/components'

const PencilBannerWrapper = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	align-items: center;
	background: ${({ theme }) => theme.pencilBanner.background};
	color: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	height: 100%;
	justify-content: flex-end;
	min-height: 150px;
	padding: 15px;
	width: 100%;

	${({ theme }) => theme.MQ.L} {
		flex-direction: row;
		min-height: 60px;
	}
`

const LeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 100%;
	padding-right: 0;

	${({ theme }) => theme.MQ.S} {
		max-width: 70%;
	}

	${({ theme }) => theme.MQ.M} {
		max-width: 60%;
	}

	${({ theme }) => theme.MQ.L} {
		flex-direction: row;
		max-width: 100%;
		padding-right: 10%;
	}
`

const TextContainer = styled.div`
	font-size: 21px;
	line-height: 32px;
	text-align: center;

	${({ theme }) => theme.MQ.L} {
		font-size: 26px;
		line-height: 40px;
	}
`

const LogoContainer = styled.span`
	max-height: 60px;
	max-width: 140px;
	padding-left: 5px;
	width: 100%;
`

const ColorText = styled.span`
    color: ${({ theme, siteName }) => (siteName === 'bdc' ? theme.colors.secondary : theme.colors.primary)}}}
`

const ButtonContainer = styled.div`
	align-self: center;
	height: 100%;
	margin: 15px 0px;
	max-height: 25px;
	max-width: 180px;
	padding-left: 0px;
	width: 100%;

	${({ theme }) => theme.MQ.L} {
		align-self: center;
		margin-bottom: 15px;
		margin: 0;
		padding-left: 20px;
	}
`

const RightContainer = styled.div`
	margin-top: 10px;

	${({ theme }) => theme.MQ.L} {
		margin-top: 0px;
	}
`

const LegalText = styled.div`
	color: #74afd0;
	font-size: 12px;
`

export function PencilBanner({ buttonUrl }) {
	const { SITE_NAME } = useTheme()

	return (
		<PencilBannerWrapper>
			<LeftContainer>
				<TextContainer>
					Limited time offer from
					<LogoContainer>
						<NextivaLogo />
					</LogoContainer>
					{' , '}
					<ColorText siteName={SITE_NAME}>Free phones</ColorText> and up to{' '}
					<ColorText siteName={SITE_NAME}>25% off!</ColorText>
				</TextContainer>
				<ButtonContainer>
					<a href={buttonUrl} rel="noreferrer sponsored nofollow noopener" target="_blank">
						<Button variant="border">Visit Site</Button>
					</a>
				</ButtonContainer>
			</LeftContainer>
			<RightContainer>
				<LegalText>*Terms and conditions apply.</LegalText>
			</RightContainer>
		</PencilBannerWrapper>
	)
}
